import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsCounterType, PmsCounterType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsCounterType>
    useData={usePmsCounterType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
